import env from "../env/env";

/**
 * Register minigame plugin in global site window
 * @param plugin
 */
export default function registerMinigameVuePlugin(plugin) {
  // to prevent reassign base object when we have >2 minigames on one page;
  if (!window[env.prefix]) {
    window[env.prefix] = {};
  }
  window[env.prefix][env.name] = plugin;
}
